import { BsSoundwave } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { measurementCommands } from "../../data";
import { useMQTT } from "../../../../../../context/MqttContext";
import { toast } from "react-hot-toast";
import { commandController } from "../../../../../../controllers/CommandController";
import axios from "../../../../../../utils/axios";
import { getToken } from "../../../../../../utils/token";

const EnergyTab = ({ loading, setloading, closeBtn }) => {
  const { id } = useParams();
  const { mqttEvents, clients } = useMQTT();

  const handleEnergy = (cmd) => {
    switch (cmd) {
      case "app":
        (async () => {
          try {
            setloading(true);
            let user = await getToken("spiral_username");
            let res = await axios.post(
              "/commands/measureenergybyapparentpower",
              {
                transactiontopic: `mqtt_${user}`,
                meterid: id,
              }
            );
            let result = commandController(res);
            if (result.type !== "success") {
              toast[result.type](result.message);
              setloading(false);
              return;
            }
            var time = setTimeout(() => {
              setloading(false);
              toast.success("Your command is being processed");
              closeBtn(false);
            }, process.env.REACT_APP_TIME);

            mqttEvents.on("message", (message) => {
              if (message.topic === `mqtt_${user}`) {
                if (!message.payloadString) return null;
                if (JSON.parse(message.payloadString).type == "APP") {
                  setloading(false);
                  closeBtn(false);
                  return clearTimeout(time);
                }
              }
            });
          } catch (err) {
            toast.error(err.message);
            setloading(false);
          }
        })();
        return;
      case "rep":
        (async () => {
          try {
            setloading(true);
            let user = await getToken("spiral_username");
            let res = await axios.post("/commands/measureenergybyrealpower", {
              transactiontopic: `mqtt_${user}`,
              meterid: id,
            });
            let result = commandController(res);
            if (result.type !== "success") {
              toast[result.type](result.message);
              setloading(false);
              return;
            }
            var time = setTimeout(() => {
              setloading(false);
              toast.success("Your command is being processed.");
              closeBtn(false);
            }, process.env.REACT_APP_TIME);

            mqttEvents.on("message", (message) => {
              if (message.topic === `mqtt_${user}`) {
                if (!message.payloadString) return null;
                if (JSON.parse(message.payloadString).type == "REP") {
                  setloading(false);
                  closeBtn(false);
                  return clearTimeout(time);
                }
              }
            });
          } catch (err) {
            toast.error(err.message);
            setloading(false);
          }
        })();
        return;
      default:
        break;
    }
  };
  return (
    <div>
      <div className="mt-4">
        <div className="font-Kanit text-center text-secondary font-semibold text-[17px]">
          Energy Measurement
        </div>
        <div className=" text-center text-gray-700 font-light w-[70%] mx-auto ">
          Use the settings below to determine how you want to measure energy
          consumed on your device.
        </div>
      </div>
      <div className="grid grid-cols-2 gap-10 mt-6 h-[150px] place-content-center">
        {measurementCommands.map(({ title, id, desc, icon, cmType }) => (
          <div
            onClick={() => handleEnergy(cmType)}
            key={id}
            className="bg-white rounded-md drop-shadow-2xl p-2 border-b-[2px] transition-all ease-out border-gray-600 hover:drop-shadow-xl hover:border-secondary cursor-pointer relative"
          >
            <div className="">
              <BsSoundwave size={25} />
            </div>
            <div className="font-semibold pt-1">{title}</div>
            <div className="font-light">{desc}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EnergyTab;
